import { render, staticRenderFns } from "./tipo_documento_crud.vue?vue&type=template&id=22b76db1"
import script from "./tipo_documento_crud.vue?vue&type=script&lang=js"
export * from "./tipo_documento_crud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports